import React, { useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';

import './CopyToClipboard.scss';
import { addModifiers } from '../../../shared/helpers';
import classcat from 'classcat';

export const CopyToClipboard = ({ value, className, onCopy }: { value: string; className?: string; onCopy?: () => void }) => {
  const [isCopied, setIsCopied] = useState(false);
  let timeout: number | null = null;

  useEffect(
    () => () => {
      if (timeout) clearTimeout(timeout);
    },
    []
  );

  return (
    <button
      className={classcat([addModifiers('copy-to-clipboard', [isCopied ? 'copied' : '']), className])}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        copy(value);
        onCopy?.();
        setIsCopied(true);
        timeout = window.setTimeout(() => {
          if (timeout) {
            setIsCopied(false);
          }
        }, 2000);
      }}
    ></button>
  );
};
